import { alpha } from "@mui/material";
import { gridClasses } from "@mui/x-data-grid";

const useStyles = (theme, editMode) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "30px",
    width: "100%",
  },
  paper: {
    width: "100%",
    minWidth: "320px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    elevation: 3,
    gap: "20px",
  },
  accordion: {
    width: "100%",
    // width: "84vw",
    // minWidth: "900px",mb:0
  },
  button: { height: "40px", minWidth: "120px", m: 1 },
  filter: { width: "180px" },
  deleButton: { width: "100px", fontWeight: "800" },
  dangerousIcon: { fontSize: 60 },
  boxDialogs: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px",
  },
  dialogText: { color: "#D32F2F" },
  porta: { width: "105px" },
  textField: { width: "230px" },
  titles: { fontWeight: 500, fontSize: "20px" },
  dataGrid: {
    height: "100%",
    fontSize: 13,
    "& .MuiDataGrid-selectedRowCount": {
      display: "none!important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    ".MuiDataGrid-cell": { display: "flex", alignItems: "center" },
    height: "800px",
    width: "100%",

    "& .Mui-error": {
      backgroundColor: `rgb(126,10,15, ${
        theme.palette.mode === "dark" ? 0 : 0.1
      })`,
      color: theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: editMode ? theme.palette.background.default : null,
    },
    "& .MuiDataGrid-cell": {
      position: "relative",
      "&::after": {
        content: '""',
        position: "absolute",
        right: 0,
        top: "25%", // 10% da parte superior para centralizar a borda
        height: "50%", // 80% da altura da célula
        width: "1px",
        backgroundColor: theme.palette.color.textDisable, // Cor da borda
      },
    },
  },
});

export default useStyles;
